<template>
    <div class="row">
        <div class="col-md-12 grid-margin">
            <div class="quest-mission-header">
                <h2 class="mr-4 mb-0">{{ usermission.mission.name }}</h2>
                <b-button
                    class="btn-clean btn-quest-cancel"
                    v-if="usermission.status == 1"
                    variant="inverse-danger"
                    @click="cancelMission">
                    <i class="fas fa-fw fa-times"></i>{{ $t('common.cancel') }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-quest-user-mission-header-component',
    props: ['usermission', 'projectId'],
    methods: {
        cancelMission() {
            this.alert
                .confirm(
                    this.$t('quest.close_assignment'),
                    this.$t('quest.all_submitted_documents_will_be_lost_this_step_is_not_reversible'),
                    this.$t('quest.close_assignment'),
                )
                .then((confirm) => {
                    if (confirm) {
                        window.location.href = this.routes.questCancelMission(
                            this.projectId,
                            this.usermission.mission.id,
                        );
                    }
                });
        },
    },
};
</script>

<style scoped>
.quest-mission-header {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: baseline;
    margin-top: 16px;
}

@media (min-width: 768px) {
    .quest-mission-header {
        flex-direction: row;
        justify-content: space-between;
        align-content: center;
    }
}
</style>
